export type FornecedorModel = {
    id: number
    nome: string
    email: string
    telefone: string
    receberEmail: boolean
    receberEmailPedidoExpirado: boolean
    receberEmailPedidoRealizado: boolean
    receberEmailPedidoCancelado: boolean
    receberEmailResumoDiario: boolean
    naoStart?: boolean
}

export const FornecedorInicial: FornecedorModel = {
    id: 0,
    nome: "",
    email: "",
    telefone: "",
    receberEmail: false,
    receberEmailPedidoExpirado: false,
    receberEmailPedidoRealizado: false,
    receberEmailPedidoCancelado: false,
    receberEmailResumoDiario: false,
}
